/**
 * An error raised by the realtime layer itself (socket setup, the websocket
 * provider). `RealtimeErrorBoundary` falls back to REST-only rendering ONLY
 * for these; every other error passes through to the app-level boundary, so
 * an unrelated render bug is never hidden behind a silent remount.
 */
export class RealtimeError extends Error {
  readonly isRealtimeError = true;

  readonly cause?: unknown;

  constructor(message: string, cause?: unknown) {
    super(message);
    this.name = "RealtimeError";
    this.cause = cause;
    // Keep `instanceof` working when the class is compiled down to ES5.
    Object.setPrototypeOf(this, RealtimeError.prototype);
  }
}

/** True for a `RealtimeError`, including one from another copy of this module. */
export const isRealtimeError = (error: unknown): error is RealtimeError =>
  error instanceof RealtimeError ||
  Boolean(
    error &&
      typeof error === "object" &&
      (error as { isRealtimeError?: unknown }).isRealtimeError === true
  );
